(() => {
  document.querySelectorAll('[data-dd-eco-accordion]').forEach((section) => {
    const items = Array.from(section.querySelectorAll('.dd-eco-item'));

    items.forEach((item) => {
      const trigger = item.querySelector('.dd-eco-item__trigger');
      const panel = item.querySelector('.dd-eco-item__panel');

      if (!trigger || !panel) return;

      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        items.forEach((otherItem) => {
          const otherTrigger = otherItem.querySelector('.dd-eco-item__trigger');
          const otherPanel = otherItem.querySelector('.dd-eco-item__panel');

          otherItem.classList.remove('is-open');
          otherTrigger?.setAttribute('aria-expanded', 'false');
          if (otherPanel) otherPanel.hidden = true;
        });

        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });
  });
})();
